import { computed, ref } from '@vue/composition-api'
import axios from 'axios'

export interface PostcodeApiResponseAddress {
    id: string,
    street: string,
    number: number,
    letter: string|null,
    addition: string|null,
    postcode: string|null,
    surface: number|null,
    nen5825: {
        street: string,
        postcode: string,
    },
    city: {
        id?: string,
        label?: string,
    },
    municipality: {
        id: string,
        label: string,
    },
    province: {
        id: string,
        label: string,
    },
    geo: {
        center: {
            wgs84: {
                type: string,
                coordinates: [number, number],
                crs: {
                    type: string,
                    properties: {
                        name: string,
                    },
                },
            },
            rd: {
                type: string,
                coordinates: [number, number],
                crs: {
                    type: string,
                    properties: {
                        name: string,
                    },
                },
            },
        },
        exterior: {
            wgs84: {
                type: string,
                coordinates: [[number, number]],
                crs: {
                    type: string,
                    properties: {
                        name: string,
                    },
                },
            },
        },
    },
    type: string,
    purpose: string,
    year: number,
}

export function usePostcodeApi() {
    const loading = ref(false)
    const hasResult = ref(false)
    const firstResult = computed(() => results.value.length === 0 ? null : results.value[0])
    const results = ref<PostcodeApiResponseAddress[]>([])

    const reset = () => {
        hasResult.value = false
        results.value = []
    }

    async function search(postcode: string, number: number|string): Promise<PostcodeApiResponseAddress[]> {
        loading.value = true
        hasResult.value = false

        try {
            const response = await axios.get('https://api.postcodeapi.nu/v2/addresses', {
                headers: {'x-api-key': '1ToA8FZ2eB9FZCvA53Ce79c83sMxVdtk2m7i58E2'},
                params: {
                    postcode,
                    number,
                },
            })

            if (response.data._embedded.addresses.length > 0) {
                hasResult.value = true
                results.value = response.data._embedded.addresses
                return results.value
            }

        } finally {
            loading.value = false
        }

        return []
    }

    return {
        loading,
        hasResult,
        firstResult,
        results,
        search,
        reset,
    }
}
